import React from 'react';

import { Text } from '@atlaskit/primitives/compiled/text';
import type { Color } from '@atlaskit/status/status';
import { Status } from '@atlaskit/status/status';

export const StatusComponent = ({
	text,
	color,
	isBold,
}: {
	text: string;
	color: Color;
	isBold: boolean;
}): React.JSX.Element => (
	<Text as="span" testId="status-component">
		<Status text={text} color={color} isBold={isBold} />
	</Text>
);
